import React, { PureComponent } from 'react';
import Fragment from 'react-dot-fragment';
import { Loader } from 'react-loaders';

import { getRequest } from '../../../../../api/ApiService';
import Auth from '../../../../../routes/Auth';

import { handleSelectChange } from '../../utils';

import BannerLayout from '../../layouts/banner';

import {
  FormulaName,
  FormulaValue
} from '../../components/ui';

class InsufficientCapital extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
      teamsToShow: [],
      selectedTeamId: 0,
      allTeamsCount: 0,
      teamFinancialsEndingCash: 0
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData = () => {
    this.setState({
      loaded: false
    });

    const { activeRound, performanceFeedbacksGame } = this.props;

    getRequest(
      `${process.env.REACT_APP_API_URL}teams/`
    ).then(res => {
      const teamsToShowIds = performanceFeedbacksGame.find(i => i.type === "Insufficient capital").teams;

      const teams = res.body;
      const teamsToShow = teams.filter(i => teamsToShowIds.includes(i.id));

      const temporaryId = Auth.getTeamId();
      const team_id = teamsToShowIds.includes(temporaryId)
        ? temporaryId
        : teamsToShowIds[0];

      getRequest([
        `${process.env.REACT_APP_API_URL}team/page/financials/?round_number=${activeRound}&team_id=${team_id}`
      ])
        .then(res => {
          const teamFinancialsEndingCash = res.body.team.ending_cash;

          this.setState({
            loaded: true,
            teamsToShow,
            selectedTeamId: Number(team_id),
            allTeamsCount: teams.length,
            teamFinancialsEndingCash
          })
        })
        .catch(err => { });
    })
      .catch(err => { });
  }

  render() {
    const {
      loaded,
      teamsToShow,
      selectedTeamId,
      allTeamsCount,
      teamFinancialsEndingCash
    } = this.state;

    const { previousShownErrors } = this.props;

    return loaded ? (
      <BannerLayout
        section="Why Targets Weren’t Hit"
        subSection="Share Price"
        alertText={`${teamsToShow.length} out of ${allTeamsCount} teams did not have sufficient capital to successfully post decisions.`}
        previousShownErrors={previousShownErrors}
        paragraph2={(
          <Fragment>
            <b>Note:</b> Some teams might have a positive cash balance. However, the positive cash balance was not enough to cover their product, marketing, and/or operation expenses.
          </Fragment>
        )}
        selectorOptions={teamsToShow}
        selectorSelectedOptionId={selectedTeamId}
        onSelectorChange={value => handleSelectChange(value, this.fetchData)}
        visual={(
          <Fragment>
            <FormulaName background="#4CC7D1" color="rgba(0, 27, 59, 0.94)">
              Insufficient Capital
            </FormulaName>
            <FormulaValue fontSize="28px">=</FormulaValue>
            <FormulaValue fontSize="40px" isNegative={teamFinancialsEndingCash < 0}>
              {teamFinancialsEndingCash.toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD',
                maximumFractionDigits: 0,
              })}
            </FormulaValue>
          </Fragment>
        )}
        visualProps={{
          borderColor: '#D5D9DD',
          background: '#D7F0F2',
          flexCenter: true,
          gap: '16px',
        }}
      />
    ) : <Loader type="ball-scale-ripple" active />;
  }
}

export default InsufficientCapital;



// WEBPACK FOOTER //
// ./src/instructor/components/performance-feedback/pages/why-targets-werent-hit/insufficient-capital.js